import { SET_PROCESSQUEUE, SYNC_PROCESSQUEUE, SET_LOADINGFLAG } from "../actions/types";

export const setProcessQueue = (payload) => {
  return {
    type: SET_PROCESSQUEUE,
    payload,
  };
};

export const syncProcessQueue = (payload) => {
  return {
    type: SYNC_PROCESSQUEUE,
    payload,
  };
};

export const updateProcessingStatus = (payload) => {
  return {
    type: SET_LOADINGFLAG,
    payload,
  };
};
